import axios from 'axios';

const Http = axios.create({
  // baseURL: 'https://en.citiesbreak.com',
});

export default Http  


// WEBPACK FOOTER //
// ./src/Axios/Axios.js